'use client'
import {
  TabIndicator
} from "./chunk-XYXC6MAF.mjs";
import {
  TabList
} from "./chunk-BXDFYXZJ.mjs";
import {
  TabPanel
} from "./chunk-KGTDXOFZ.mjs";
import {
  TabPanels
} from "./chunk-4YMKQ5D4.mjs";
import {
  Tab
} from "./chunk-IAXSQ4X2.mjs";
import {
  Tabs,
  useTabsStyles
} from "./chunk-GTRZJDIL.mjs";
import {
  TabsDescendantsProvider,
  TabsProvider,
  useTab,
  useTabIndicator,
  useTabList,
  useTabPanel,
  useTabPanels,
  useTabs,
  useTabsContext,
  useTabsDescendant,
  useTabsDescendants,
  useTabsDescendantsContext
} from "./chunk-NXSBASJ3.mjs";
export {
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabsDescendantsProvider,
  TabsProvider,
  useTab,
  useTabIndicator,
  useTabList,
  useTabPanel,
  useTabPanels,
  useTabs,
  useTabsContext,
  useTabsDescendant,
  useTabsDescendants,
  useTabsDescendantsContext,
  useTabsStyles
};
//# sourceMappingURL=index.mjs.map